import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess304006Status: 'idle',
    startProcess304006Error: undefined as any,
    loadUserParamsProcess304006Status: 'idle',
    loadUserParamsProcess304006Error: undefined as any,

    process304006List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess304006 = createAsyncThunk('process304006Slice/startProcess304006', async ({ process304006 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess304006/`,
        prepareData(process304006),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess304006Status } = getState().process304006Slice
        return startProcess304006Status !== 'pending'
    }
})

export const loadUserParamsProcess304006 = createAsyncThunk('process304006Slice/loadUserParamsProcess304006', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess304006/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess304006Status } = getState().process304006Slice
        return loadUserParamsProcess304006Status !== 'pending'
    }
})

const Process304006Slice = createSlice({
    name: 'process304006Slice',
    initialState,
    reducers: {
        resetstartProcess304006: (state) => {
            state.job = undefined
            state.startProcess304006Error = undefined
        },
        resetstartProcess304006Error: (state) => {
            state.startProcess304006Error = undefined
        },
        resetloadUserParamsProcess304006: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess304006Error = undefined
        },
        resetloadUserParamsProcess304006Error: (state) => {
            state.loadUserParamsProcess304006Error = undefined
        },
        removeFromProcess304006ListById: (state, action) => {
            state.process304006List = state.process304006List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess304006ListByIds: (state, action) => {
            state.process304006List = state.process304006List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process304006List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess304006Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process304006List = []
            state.startProcess304006Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess304006.pending, (state) => {
            state.startProcess304006Status = 'pending'
            state.startProcess304006Error = undefined
        })
        builder.addCase(startProcess304006.fulfilled, (state, action) => {
            state.startProcess304006Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess304006.rejected, (state, action) => {
            state.startProcess304006Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess304006Error = action.error.message
            } else {
                state.startProcess304006Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess304006.pending, (state) => {
            state.loadUserParamsProcess304006Status = 'pending'
            state.loadUserParamsProcess304006Error = undefined
        })
        builder.addCase(loadUserParamsProcess304006.fulfilled, (state, action) => {
            state.loadUserParamsProcess304006Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess304006.rejected, (state, action) => {
            state.loadUserParamsProcess304006Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess304006Error = action.error.message
            } else {
                state.loadUserParamsProcess304006Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess304006,
    resetstartProcess304006Error,
    resetloadUserParamsProcess304006,
    resetloadUserParamsProcess304006Error,
    removeFromProcess304006ListById,
    removeFromProcess304006ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process304006Slice.actions
export default Process304006Slice.reducer
